const sp = 'São Paulo'

const cityOptions = [
  sp,
  'Barueri',
  'Campinas',
  'Carapicuíba',
  'Cotia',
  'Diadema',
  'Guarulhos',
  'Jundiaí',
  'Osasco',
  'Santana de Parnaíba',
  'Santo André',
  'São Bernardo do Campo',
  'São Caetano do Sul',
  'São José dos Campos',
  'Sorocaba',
  'Taboão da Serra',
  'Outras Cidades'
]

export { cityOptions, sp }
